module.exports = __webpack_public_path__ + "static/media/Match-Up.574fe03d.png";